import {useEffect} from 'react'
import './style.scss'
import {useDispatch, useSelector} from 'react-redux'
import {AppActions} from 'store/modules/app/actions'

export const Variants = {
  info: 'bg-info',
  primary: 'bg-primary',
  secondary: 'bg-secondary',
  success: 'bg-success',
  warning: 'bg-warning',
  danger: 'bg-danger'
}

export const Snackbar = props => {
  const dispatch = useDispatch()
  const {show, notification, variant, delay} = useSelector(state => state.app.notification)

  const close = () => {
    dispatch(AppActions.closeNotification())
  }

  useEffect(() => {
    setTimeout(() => {
      close()
    }, delay)
  }, [show])

  return (
    <div className={`snackbar ${Variants[variant] || 'bg-primary'} ${show ? 'show' : 'hidden'}`}>
      <div className="wrapper">
        <div className="message">{notification}</div>
        <div className="close" onClick={close}>
          <div className="icon">
            <i className="fal fa-times text-light"></i>
          </div>
        </div>
      </div>
    </div>
  )
}
